const State = {
  stockAdjustList: []
}

export default State
